import {
  SEARCH_USER_USE_CASE,
  SearchUserUseCase,
  GetUserByIdUseCase,
  GET_USER_BY_ID_USE_CASE,
  GetUsersUseCase,
  GET_USERS_USE_CASE,
  IUserRepository,
  USER_REPOSITORY,
  CHANGE_TEST_MAKER_LOCALE_USE_CASE,
  ChangeTestMakerLocaleUseCase,
  GET_TEST_MAKER_LOCALE_USE_CASE,
  GetTestMakerLocaleUseCase,
} from '@module/user';

export const userUseCaseProviders: any = [
  {
    provide: SEARCH_USER_USE_CASE,
    useFactory: (repository: IUserRepository) => new SearchUserUseCase(repository),
    inject: [USER_REPOSITORY],
  },
  {
    provide: GET_USERS_USE_CASE,
    useFactory: (userRepository: IUserRepository) => {
      return new GetUsersUseCase(userRepository);
    },
    inject: [USER_REPOSITORY],
  },
  {
    provide: GET_USER_BY_ID_USE_CASE,
    useFactory: (userRepository: IUserRepository) => {
      return new GetUserByIdUseCase(userRepository);
    },
    inject: [USER_REPOSITORY],
  },
  {
    provide: CHANGE_TEST_MAKER_LOCALE_USE_CASE,
    useFactory: (userRepository: IUserRepository) => {
      return new ChangeTestMakerLocaleUseCase(userRepository);
    },
    inject: [USER_REPOSITORY],
  },
  {
    provide: GET_TEST_MAKER_LOCALE_USE_CASE,
    useFactory: (userRepository: IUserRepository) => {
      return new GetTestMakerLocaleUseCase(userRepository);
    },
    inject: [USER_REPOSITORY],
  },
];
